// components/Popup.js
import React, { useEffect, useRef } from 'react';
import './Popup.css';

const Popup = ({ 
    children, 
    onClose, 
    className = '', 
    overlayClassName = '',
    title = '',
    showHeader = true
}) => {
    const popupRef = useRef(null);

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('popup-overlay')) {
            onClose();
        }
    };

    return (
        <div className={`popup-overlay ${overlayClassName}`} onClick={handleOverlayClick}>
            <div className={`popup-content ${className}`} ref={popupRef}>
                {showHeader && (
                    <div className="popup-header">
                        {title && <h2>{title}</h2>}
                        <button className="close-button" onClick={onClose}>×</button>
                    </div>
                )}
                <div className="popup-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Popup;
